import { render, staticRenderFns } from "./PluginBanner.vue?vue&type=template&id=155f6bfd&lang=html&"
import script from "./PluginBanner.vue?vue&type=script&lang=js&"
export * from "./PluginBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports